import { MAX_PLAYS_COUNT, normalizePlaysCount } from './playsCount';

export const MAX_PROFILE_PLAYS_COUNT = MAX_PLAYS_COUNT;

export const getLoadedProfilePlaysCount = (profileSummary) => {
    const profile = profileSummary?.profile;
    if (!profile || typeof profile !== 'object') {
        return null;
    }

    const rawValue = profile.playsCount;
    if (rawValue === null || rawValue === undefined || rawValue === '') {
        return 0;
    }

    return normalizePlaysCount(rawValue);
};
